<template>
  <v-layout row
            style="z-index:100; position:inherit"
            v-if="isMobile">
    <v-flex xs12>
      <v-list two-line>
        <v-list-tile @click="downloadAll">
          <v-list-tile-avatar>
            <img src="/image/public/store_logo.png" />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              wesmartPark
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{ $t('installApp.description') }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="isApple">
            {{ $t('installApp.install') }}
          </v-list-tile-action>
          <v-list-tile-action v-else>
            <v-btn small flat :href="android">{{ $t('installApp.install')+' Google' }}</v-btn>
            <v-btn small flat :href="huawei">{{ $t('installApp.install')+' Huawei' }}</v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
import store from '@/store';
import utilService from '@/services/utilService';

const configFile = require(process.env.VUE_APP_CONFIG)
const config = configFile.config

export default {
  name: 'InstallApp',
  watch: {

  },
  computed: {
    isApple() {
      return utilService.isApple();
    },
    android() {
      return config.SITE[store.state.countrySelected.code].APP.ANDROID
    },
    huawei() {
      return 'https://appgallery.cloud.huawei.com/ag/n/app/C101270523?channelId=site&id=163e069517e04686b02f8d00b7973422&s=02CA11903D7DF1B04BF3D189381E0FDC71058552C1D62C27E9F412F0C1F9A8F8&detailType=0&v='
    }
  },
  data() {
    return {
      isMobile: this.$vuetify.breakpoint.xsOnly
    };
  },
  methods: {
    downloadAll() {
      window.open(utilService.downloadApp())
    }
  }
};
</script>